import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import useStyle from 'shared/hooks/useStyle'

import styles from './ProcessBar.style'

const propTypes = {
    groups: PropTypes.arrayOf(PropTypes.shape({
        progressGroup: PropTypes.number.isRequired,
        steps: PropTypes.arrayOf(PropTypes.shape({ isRequired: PropTypes.bool.isRequired }))
            .isRequired,
    })).isRequired,
    current: PropTypes.shape({ progressGroup: PropTypes.number }),
}

const ProcessBar = ({
    groups,
    current,
}) => {
    const classes = useStyle(styles)

    return (
        <div css={classes.root}>
            <div css={classes.main}>
                {groups.map(({
                    progressGroup,
                    steps,
                }) => {
                    const mainSteps = steps.filter(({ isNestedStep }) => {
                        return !isNestedStep
                    })
                    const className = [
                        classes.group,
                        progressGroup === current.progressGroup && classes.current,
                        !mainSteps.filter(({ isNestedStep }) => {
                            return !isNestedStep
                        }).some((step) => {
                            return isEmpty(step.userInput)
                        }) && classes.fullyAnswered,
                        mainSteps.some((step) => {
                            return isEmpty(step.userInput) && step.isRequired
                        }) && classes.unAnsweredMandatory,
                    ]

                    return (
                        <div
                            key={progressGroup}
                            css={className}
                        />
                    )
                })}
            </div>
        </div>
    )
}

ProcessBar.propTypes = propTypes

export default ProcessBar
